import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

declare global {
  interface Window {
    WOW: any;
  }
}

interface Child {
  id: string;
  name: string;
  age: number;
  image: string;
  medical_condition: string;
  bio: string;
}

const ChildDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [child, setChild] = useState<Child | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch child from API
    if (id) {
      fetch(`http://localhost:5000/api/children/${id}`)
        .then(res => res.json())
        .then(data => {
          setChild(data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching child:', error);
          setLoading(false);
        });
    }
  }, [id]);

  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  }, [child]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <p>Loading...</p>
      </div>
    );
  }

  if (!child) {
    return (
      <div className="text-center py-5">
        <h3>Child not found</h3>
        <Link to="/children" className="btn btn-primary mt-3">Back to Our Children</Link>
      </div>
    );
  }

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">{child.name}</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <Link to="/">Home</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i></span>
            <Link to="/about">About Us</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i></span>
            <Link to="/children">Our Children</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i>{child.name}</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {/* Child single area start here */}
      <section className="team-single pt-120 pb-120">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-4 col-md-6">
              <div className="team-single__image">
                <img 
                  src={child.image || '/assets/images/children/child1.jpg'} 
                  alt={child.name}
                  style={{ width: '100%', height: '451px', objectFit: 'cover' }}
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="team-single__content">
                <div className="title pb-20 mb-20 bor-bottom">
                  <h3>{child.name}</h3>
                  <span className="primary-color mt-1">Age: {child.age} years {child.medical_condition && `• ${child.medical_condition}`}</span>
                </div>
                <div className="team-single__info">
                  <h4 className="pb-2">About {child.name}</h4>
                  <div dangerouslySetInnerHTML={{ __html: child.bio }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Child single area end here */}
    </>
  );
};

export default ChildDetail;
